<template>
  <div>
    <listFilter
      :formItems="formItems"
      :filter="filter"
      @searchTableInfo="searchTableInfo"
      @resetTableInfo="resetTableInfo"
    />
    <div class="tableWrap">
      <div class="leftButtonBox">
        <CustomButton
          type="primary"
          :permissionCode="authType.tplGroupManage.create"
          @click="openTempGroupModal({ isEdit: false })"
        >
          新建模版组
        </CustomButton>
        <CustomButton
          type="warning"
          :permissionCode="authType.tplGroupManage.export"
          @click="exportExcel"
        >
          导出
        </CustomButton>
      </div>
      <Table
        border
        :columns="columns"
        size="small"
        stripe
        :data="dataSource"
        disabled-hover
        row-key="id"
        ref="tableRef"
      ></Table>
      <div style="margin: 10px; overflow: hidden">
        <div style="float: right">
          <Page
            show-total
            show-sizer
            :total="totalCount"
            :current="filter.pageIndex"
            :page-size="filter.pageSize"
            :page-size-opts="[10, 25, 50, 100]"
            @on-change="changePage"
            @on-page-size-change="pageSizeChange"
          />
        </div>
      </div>
    </div>
    <!-- 新建编辑弹框 -->
    <Modal
      v-model="tempGroupModalVisible"
      :title="tempGroupModalTitle"
      :isEdit="isEdit"
      :mask-closable="false"
    >
      <TempGroupModal
        v-if="tempGroupModalVisible"
        ref="tempGroupModal"
        :isEdit="isEdit"
        :id="currentRowId"
      />
      <template #footer>
        <Button @click="tempGroupModalVisible = false">取消</Button>
        <Button type="primary" @click="handlerSubmit">确认</Button>
      </template>
    </Modal>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import listMixins from '@/mixins/listMixins';
import getPermissionMixin from '@/mixins/getPermissionMixin';
import { exportTempGroupList } from '@/api/tempGroupManage';
import { formItems, getColumns } from './config';
import { TempGroupModal } from './compoments';
import authType from '@/config/authType';
export default {
  name: 'tempGroupManage',
  mixins: [getPermissionMixin, listMixins],
  components: { TempGroupModal },
  data() {
    return {
      authType,
      formItems,
      filter: {
        pageIndex: 1,
        pageSize: 10
      },
      columns: getColumns({
        edit: this.openTempGroupModal,
        toggleStatus: this.toggleStatus
      }),
      tempGroupModalVisible: false,
      isEdit: false,
      currentRowId: ''
    };
  },
  computed: {
    ...mapState('tempGroupManage', ['totalCount', 'dataSource']),
    tempGroupModalTitle() {
      return this.isEdit ? '编辑模版组' : '新增模版组';
    }
  },
  methods: {
    ...mapActions('tempGroupManage', ['getTableInfo', 'submitStatus']),
    openTempGroupModal({ isEdit, id: currentRowId }) {
      // isEdit 是否是编辑 true 为编辑 false 为新增
      this.tempGroupModalVisible = true;
      this.isEdit = isEdit;
      this.currentRowId = currentRowId;
    },
    exportExcel() {
      const { pageIndex, pageSize, ...rest } = this.filter;
      const params = { ...rest };
      exportTempGroupList(params, '模版组管理');
    },
    handlerSubmit() {
      this.$refs.tempGroupModal.submit().then(res => {
        if (res) {
          this.tempGroupModalVisible = false;
          this.getTableInfo({ filter: this.filter });
        }
      });
    },
    toggleStatus({ id, status }) {
      // status = 0 status = 0 停用， 1 启用 状态， 所以文字展示要相反
      const title = status ? '停用' : '启用';
      const content = status
        ? '停用后分组内审批模板不会被删除，将会进入到「其他」分组。'
        : '确认后将会启用该模板组';
      const that = this;
      this.$Modal.confirm({
        title,
        content,
        okText: `确认${title}`,
        loading: true,
        onOk: () => {
          this.submitStatus({ id, status }).then(res => {
            if (res) {
              this.$Message.success('操作成功');
              this.getTableInfo({ filter: this.filter });
              this.$Modal.remove();
            }
          });
        }
      });
    }
  }
};
</script>
<style lang="less"></style>
